<main>
  <app-banner></app-banner>
  <app-about></app-about>
  <app-jobs></app-jobs>
  <app-projects></app-projects>
  <app-skills></app-skills>
  <app-contact></app-contact>
</main>
